/**
 * Feature Flags Configuration
 * Centralized feature toggles for the bundle drawer system
 *
 * Usage:
 * if (window.FEATURE_FLAGS.SANTA_VIDEO_UPSELL) {
 *   // Show Santa Video upsell
 * }
 */

window.FEATURE_FLAGS = {
  /**
   * Santa Video Upsell - AI-generated personalised Santa videos
   * Product SKU: ANI-VIDEO-V1
   * Price: £67 (down from £99)
   * Status: In Development
   *
   * Enable this to show the Santa Video upsell in the personalization section
   */
  SANTA_VIDEO_UPSELL: true, // Set to true to enable

  /**
   * Future feature flags can be added here
   */
  // EASTER_BUNNY_VIDEO: false,
  // BIRTHDAY_VIDEO: false,
};
